/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sync/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconKeyboardArrowLeftFilled from 'DesignSystem/Svgs/TysiaIconKeyboardArrowLeftFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Sync({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Sync.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-bpH4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Sync.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-bpH4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-bpH4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconKeyboardArrowLeftFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconKeyboardArrowLeftFilled`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Back"
/>
</React.Fragment>
)}
</TysiaButton>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceXs}
 level="h2"
 text="Sync patient records"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
 text="Sync patients between Greyfinch and 3rd party app"
/>
</div>
<div
  data-testid="Sync.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-bpH4': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceL}
/>
<div
  data-testid="Sync.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-bpH4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-bpH4': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-5-bpH4': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
</div>
</div>
</div>
{children}
</React.Fragment>)
}